import React from "react";

import { FontAwesomeIcon }
from "@fortawesome/react-fontawesome";

import {
    faDesktop,
    faFilm,
    faUsers,
    faCouch,
    faUtensils
}
from "@fortawesome/free-solid-svg-icons";


export default function MobileUtilisationCard({
    title,
    icon,
    color,
    worksettings,
    observations,
    average,
    peak,
    clickFunction
})
{

    //--------------------------------------------------------
    // Icons
    //--------------------------------------------------------

    const iconMap =
    {
        desktop: faDesktop,
        film: faFilm,
        users: faUsers,
        couch: faCouch,
        utensils: faUtensils
    };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div
            className="mobile-utilisation-card"
            onClick={clickFunction}
        >

            <div
                className="mobile-utilisation-card-icon"
                style={{
                    background:
                        `linear-gradient(
                            180deg,
                            ${color} 0%,
                            ${color}dd 100%
                        )`
                }}
            >

                <FontAwesomeIcon
                    icon={iconMap[icon]}
                />

            </div>


            <div className="mobile-utilisation-card-content">


                {/*-------------------------------------------
                    Header
                -------------------------------------------*/}

                <div
                    className="mobile-utilisation-card-title"
                    style={{
                        color: color
                    }}
                >
                    {title}
                </div>


                {/*-------------------------------------------
                    Metrics
                -------------------------------------------*/}

                <div className="mobile-utilisation-card-metrics">


                    <div className="mobile-utilisation-card-metric">

                        <div className="mobile-utilisation-card-value">
                            {worksettings || "—"}
                        </div>

                        <div className="mobile-utilisation-card-label">
                            Worksettings
                        </div>

                    </div>


                    <div className="mobile-utilisation-card-separator"/>


                    <div className="mobile-utilisation-card-metric">

                        <div className="mobile-utilisation-card-value">
                            {observations || "—"}
                        </div>

                        <div className="mobile-utilisation-card-label">
                            Observations
                        </div>

                    </div>


                    <div className="mobile-utilisation-card-separator"/>


                    <div className="mobile-utilisation-card-metric">

                        <div className="mobile-utilisation-card-value">
                            {average || "—"}
                        </div>

                        <div className="mobile-utilisation-card-label">
                            Avg Utilisation
                        </div>

                    </div>


                </div>


                {/*-------------------------------------------
                    Peak
                -------------------------------------------*/}

                <div className="mobile-utilisation-card-peak">

                    <span className="mobile-utilisation-card-peak-value">
                        {peak || "—"}
                    </span>

                    <span className="mobile-utilisation-card-peak-label">
                        Peak Utilisation
                    </span>

                </div>


            </div>

        </div>

    );

}